export default [
  [
    {
      id: 'refId',
      label: 'เลขที่ใบปะยาง',
      type: 17,
      span: 6,
      offset: 0,
      props: { padding: '8px 0' },
    }, {
      id: 'status',
      label: 'สถานะ',
      type: 12,
      span: 6,
      offset: 0,
      props: { padding: '8px 0' },
    }, {
      id: 'rejectReason',
      label: 'เหตุผล',
      type: 11,
      span: 6,
      offset: 0,
      props: { padding: '8px 0' },
    }, {
      id: 'patchDate',
      label: 'วันที่แจ้งปะยาง *',
      span: 6,
      offset: 0,
      type: 8,
      props: { padding: '8px 0' },
    },
  ], [
    {
      id: 'serialId',
      label: 'เบอร์ยาง *',
      type: 3.1,
      span: 6,
      offset: 0,
      props: {
        margin: '0 0 16px 0', padding: '8px 0', width: '100%', title: { text: 'เบอร์ยาง *' },
      },
    }, {
      id: 'driverId',
      label: 'ผู้แจ้งซ่อม *',
      type: 3.2,
      span: 6,
      offset: 0,
      props: {
        margin: '0 0 16px 0', padding: '8px 0', width: '100%', title: { text: 'ผู้แจ้งซ่อม *' },
      },
    },
  ], [
    {
      id: 'tireData',
      label: 'ข้อมูลยาง',
      type: 13,
      span: 24,
      offset: 0,
      props: {
        margin: '0 0 16px 0', padding: '8px 0', width: '100%', title: { text: 'ข้อมูลยาง' },
      },
    },
  ], [
    {
      id: 'price',
      type: 0,
      span: 6,
      offset: 0,
      props: {
        margin: '0 0 16px 0', width: '100%', title: { text: 'ราคา *' },
      },
    }, {
      id: 'type',
      type: 3.3,
      span: 6,
      offset: 0,
      label: 'ประเภทการปะยาง *',
      props: {
        margin: '0 0 16px 0', padding: '8px 0', width: '100%', title: { text: 'ประเภทการปะยาง *' },
      },
    }, {
      id: 'tirepatchstoreId',
      type: 3.4,
      span: 12,
      offset: 0,
      label: 'ร้าน *',
      props: {
        margin: '0 0 16px 0', width: '100%', title: { text: 'ร้าน *' },
      },
    }, {
      id: 'phoneNumber',
      type: 16,
      span: 6,
      offset: 0,
      props: {
        margin: '0 0 16px 0', width: '100%', title: { text: 'เบอร์โทรศัพท์ *' },
      },
    }, {
      id: 'address',
      type: 16,
      span: 18,
      offset: 0,
      props: {
        margin: '0 0 16px 0', width: '100%', title: { text: 'ที่อยู่' },
      },
    },
  ], [
    {
      id: 'description',
      span: 24,
      type: 7,
      label: 'หมายเหตุ',
      props: { padding: '8px 0' },
    }, {
      id: 'files',
      span: 24,
      type: 5,
      props: { margin: '8px 0' },
    },
  ], [
    {
      id: 'paidDate',
      span: 24,
      type: 14,
      props: { padding: '8px 0' },
    }, {
      id: 'totalPaid',
      span: 24,
      type: 15,
      props: { margin: '8px 0' },
    },
  ],
]
